import * as React from 'react';
import { cn } from '../../../ui';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../../ui';

function ConfidenceBar({ confidence = 0, className }) {
  const pct = Math.max(0, Math.min(100, confidence));
  const color = pct >= 80 ? 'var(--green)' : pct >= 70 ? 'var(--yellow)' : 'var(--red-critical)';
  const label = pct >= 80 ? 'High confidence' : pct >= 70 ? 'Moderate confidence' : 'Low confidence — review suggested';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('inline-flex items-center gap-1.5 shrink-0', className)}>
          <span className="text-caption text-text-muted">AI</span>
          <span
            className="relative h-1.5 w-12 rounded-full overflow-hidden"
            style={{ backgroundColor: 'var(--surface)' }}
          >
            <span
              className="absolute inset-y-0 left-0 rounded-full transition-all"
              style={{ width: `${pct}%`, backgroundColor: color }}
            />
          </span>
          <span className="text-caption text-text-muted">{pct}%</span>
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}

export { ConfidenceBar };
